/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(5);
	
	jQuery(document).ready(function ($) {
	  var $addressWidget = $('.acf-address-field');
	
	  $addressWidget.each(function (index, element) {
	    var $el = $(element),
	        name = $el.data('name'),
	        value = $el.data('value'),
	        layout = $el.data('layout'),
	        options = $el.data('options');
	
	    value = $.extend({
	      street1: null,
	      street2: null,
	      street3: null,
	      city: null,
	      state: null,
	      zip: null,
	      country: null
	    }, value);
	
	    $.each(layout, function (rowIndex, row) {
	      var $ul = $('<ul/>');
	      $.each(row, function (col, obj) {
	        var $li = $('<li/>');
	        var propName = name + '[' + obj.id + ']';
	        $li.append($('<label/>').prop('for', propName).text(options[obj.id].label));
	
	        $li.append($('<input type="text"/>').prop('name', propName).prop('value', value[obj.id]).prop('placeholder', options[obj.id].defaultValue));
	        $ul.append($li);
	      });
	      $el.append($ul);
	    });
	  });
	});

/***/ },

/***/ 5:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }

/******/ });


/** WEBPACK FOOTER **
 ** render_field.b35eeab0e320fe5f625c.js
 **/